var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"shouye"},[_c('h1',[_vm._v("欢迎使用自造窗后台管理系统！")]),_c('h2',[_vm._v("Welcome to use WinDoor Craft system!")])])}]

export { render, staticRenderFns }